import React, { useEffect } from 'react';
import { SuggestedOffer } from '../../types';
import { AutoCompleteForm, useAutoCompleteFetchState } from '../AutoComplete';
import { ProductCard } from '../ProductCard';
import { StateController } from '../SideMenu/ShopperExperience/useStateControllerRef';
import { useSimilarItemsSettings } from './useSimilarItemsSettings';
import { PermittedRouteMap } from '../../../../app-routes';
import { PreviewFeature } from '../../../../services';

interface Props {
  shopId: number;
  offer: SuggestedOffer | null;
  onOfferChange: (offer: SuggestedOffer | null) => void;
  stateController: StateController<string>;
  selectedExperience?: PreviewFeature;
  permittedRouteMap: PermittedRouteMap;
  openProductDetailsModal: (sku?: string) => void;
  locale: string;
}

export function SimilarItemsSettings({
  shopId,
  offer,
  onOfferChange,
  stateController: { value, setValue },
  selectedExperience,
  permittedRouteMap,
  openProductDetailsModal,
  locale,
}: Props): JSX.Element {
  useSimilarItemsSettings(shopId, locale);

  const { reset, ...autoCompleteProps } = useAutoCompleteFetchState({
    shopId,
    onOfferChange,
    selectedExperience,
    initialValue: value,
    permittedRouteMap,
    locale,
  });

  const offersImage = offer?.imageUrl || offer?.ctlImageUrl || '';
  const offersSKU = offer ? offer.sku : '';
  const suggestedOffer = {
    ...offer,
    sku: offersSKU,
    imageUrl: offersImage,
  };

  useEffect(() => {
    setValue(autoCompleteProps.selectedValue);
  }, [autoCompleteProps.selectedValue]);

  return (
    <>
      <AutoCompleteForm
        title='When shopper is viewing product...'
        placeholder='Search by description, brand, sku...'
        openPopUp
        {...autoCompleteProps}
      />
      {!!offer && (
        <ProductCard
          key={offer.sku}
          offer={suggestedOffer}
          onClose={reset}
          openProductDetailsModal={openProductDetailsModal}
        />
      )}
    </>
  );
}
